import { toast as e } from "../../../components/toast.mjs";
import { useTranslation as t } from "../../../i18n.mjs";
import { ImageModeEnum as n, ImageNameEnum as r } from "../image-enum.mjs";
import { addExistingImageSrc as i, addUploadedImageSrc as a, hasUploadedImageSrc as o } from "./state.mjs";
import { isImageNode as s, isLocalFileUrl as c, isValidUploadedImage as l, loadImageFromUrl as u, removeUploadingImage as d } from "./utils.mjs";
import { fileInputAcceptTypes as f, isAcceptTypeValid as p, useFileUploader as m } from "@systemeio/file-manager";
//#region src/extensions/image-extension/use-image-drop-and-upload/index.ts
var h = 300, g = (g) => {
	let { t: _ } = t(), { createFileUploader: v } = m(), y = async (t, n, r) => {
		try {
			let i = await v().upload({
				file: t,
				source: g
			});
			if (!i) {
				e.error(_("global.error")), d(r, n);
				return;
			}
			r.state.doc.descendants((e, t) => {
				if (s(e) && e.attrs.uploadingProps?.id === n) {
					let n = {
						...e.attrs,
						src: i.path,
						uploadingProps: null
					};
					return r.dispatch(r.state.tr.setNodeMarkup(t, null, n).setMeta("addToHistory", !1)), a(i.path), !1;
				}
				return !0;
			});
		} catch {
			e.error(_("global.error")), d(r, n);
		}
	}, b = async (e, t, i) => {
		if (e.length === 0) return;
		let a = e.map(async (e) => {
			let t = crypto.randomUUID(), n = URL.createObjectURL(e), r = new Image();
			return r.src = n, await new Promise((e) => {
				r.onload = () => e();
			}), {
				file: e,
				id: t,
				src: n,
				width: r.naturalWidth,
				height: r.naturalHeight
			};
		}), o = await Promise.all(a), { schema: s } = t.state, c = t.state.tr, l = 0;
		o.forEach(({ id: e, src: t, width: a, height: o }) => {
			let u = s.nodes[r.Block];
			if (!u) return;
			let d = u.create({
				src: t,
				width: a,
				height: o,
				containerWidth: "auto",
				imageMode: n.BlockCenter,
				uploadingProps: {
					isUploading: !0,
					id: e
				}
			});
			c = c.insert(i + l, d), l += d.nodeSize;
		}), t.dispatch(c), o.forEach(({ file: e, id: n }) => {
			y(e, n, t);
		});
	};
	return {
		onDrop: (e, t) => {
			if (!t.dataTransfer) return;
			let n = Array.from(t.dataTransfer.files).filter((e) => p(e.type, f.image ?? []));
			if (n.length === 0) return !1;
			t.preventDefault();
			let r = e.posAtCoords({
				left: t.clientX,
				top: t.clientY
			});
			return b(n, e, r?.pos ?? 1), !0;
		},
		onPaste: (t, n) => {
			if (!n.clipboardData) return;
			let { clipboardData: r } = n, { selection: a } = t.state, { from: s } = a;
			t.state.doc.descendants((e) => (l(e) && i(e.attrs.src), !0));
			let m = Array.from(r.files).filter((e) => p(e.type, f.image ?? []));
			if (m.length > 0) return n.preventDefault(), b(m, t, s), !0;
			let g = r.getData("text/html");
			return g && g.includes("<img") && setTimeout(() => {
				let n = [];
				t.state.doc.descendants((e, r) => {
					if (!l(e)) return !0;
					let i = e.attrs.src;
					if (o(i)) return !0;
					if (c(i)) {
						let n = t.state.tr.delete(r, r + e.nodeSize);
						return t.dispatch(n), !0;
					}
					let a = crypto.randomUUID();
					return n.push({
						pos: r,
						src: i,
						id: a
					}), !0;
				}), n.length !== 0 && (n.forEach(({ pos: e, id: n }) => {
					let r = t.state.doc.nodeAt(e);
					if (!r) return;
					let i = {
						...r.attrs,
						uploadingProps: {
							isUploading: !0,
							id: n
						}
					};
					t.dispatch(t.state.tr.setNodeMarkup(e, null, i).setMeta("addToHistory", !1));
				}), n.forEach(async ({ id: n, src: r }) => {
					let i = await u(r);
					if (!i) {
						e.error(_("global.error")), d(t, n);
						return;
					}
					y(i, n, t);
				}));
			}, h), !1;
		}
	};
};
//#endregion
export { g as useImageDropAndUpload };
